import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '../../pages/Settings/SettingsPage'
import { SettingsTab } from '../../types/settings.types'

/**
 * Settings Route Component
 * Layout (MainLayout, Sidebar) provided by parent _authenticated route
 * Sessions panel automatically hidden for settings route in parent
 */
const SettingsRouteComponent = () => {
  return <SettingsPage />
}

/**
 * Route Configuration
 * Path: /_authenticated/settings
 * - Authentication inherited from _authenticated parent (no requireAuth needed)
 * - MainLayout structure inherited from _authenticated parent
 * - Sessions panel hidden automatically (parent checks location.pathname)
 */
interface SettingsSearch {
  tab?: SettingsTab
}

export const Route = createFileRoute('/_authenticated/settings')({
  validateSearch: (search: Record<string, unknown>): SettingsSearch => {
    return {
      tab: (search.tab as SettingsTab) || undefined,
    }
  },
  component: SettingsRouteComponent,
})
